import React, { createContext } from 'react';
import { useDarkMode } from './useDarkMode'; // Corrected import path

export const DarkModeContext = createContext();

export const DarkModeProvider = ({ children }) => {
  const [darkMode, setDarkMode] = useDarkMode(); // Use the custom hook

  return (
    <DarkModeContext.Provider value={{ darkMode, setDarkMode }}>
      {children}
    </DarkModeContext.Provider>
  );
};
